const initialState = {
  data: [],
  loading: false,
  templates: [],
  templates_loading: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'table.planning_library/SET_TABLE_PARAMS':
      return {
        ...state,
        ...action.params,
      };
    case 'table.planning_library/LIST_PLANNING_LIBRARY_ITEMS_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'table.planning_library/LIST_PLANNING_LIBRARY_ITEMS_SUCCESS':
      return {
        ...state,
        data: action.response.data,
        loading: false,
      };
    case 'table.planning_library/LIST_PLANNING_LIBRARY_ITEMS_FAILURE':
      return {
        ...state,
        loading: false,
      };
    case 'table.planning_library/LIST_PLANNING_TEMPLATES_REQUEST':
      return {
        ...state,
        templates_loading: true,
      };
    case 'table.planning_library/LIST_PLANNING_TEMPLATES_SUCCESS':
      return {
        ...state,
        templates: action.response.data,
        templates_loading: false,
      };
    case 'table.planning_library/LIST_PLANNING_TEMPLATES_FAILURE':
      return {
        ...state,
        templates_loading: false,
      };
    default:
      return state;
  }
}
